/**
 * Common response extraction helpers - avoids repeating response?.data?.list ?? response?.list ?? [] patterns
 */
export const extractList = (response) => {
  if (!response) return [];
  const nested =
    response?.data?.list ??
    response?.data?.data?.list ??
    response?.list;
  if (Array.isArray(nested)) return nested;
  if (Array.isArray(response?.data)) {
    return response.data;
  }
  if (Array.isArray(response?.data?.data)) {
    return response.data.data;
  }
  if (Array.isArray(response)) return response;
  return [];
};

export const extractData = (response) => response?.data ?? response;

export const extractPagination = (response) => {
  const pag =
    response?.data?.pagination ??
    response?.pagination ??
    response?.data?.meta ??
    response?.meta;

  if (pag && typeof pag === 'object' && !Array.isArray(pag)) {
    return {
      total: pag.total ?? pag.total_count ?? 0,
      page: pag.current_page ?? pag.page ?? 1,
      per_page: pag.per_page ?? 10,
    };
  }
  
  if (response && typeof response.total === 'number') {
    return {
      total: response.total,
      page: response.current_page ?? response.page ?? 1,
      per_page: response.per_page ?? 10,
    };
  }
  return { total: 0, page: 1, per_page: 10 };
};
